/**
 * 工具类
 * <tian.xu96@qq.com>
 * */

import FormatUtil from '@/utils/format'
import AuthUtil from '@/utils/auth'
import HelperUtil from '@/utils/helper'

const install = function (Vue) {
  Vue.$FormatUtil = Vue.prototype.$FormatUtil = FormatUtil
  Vue.$AuthUtil = Vue.prototype.$AuthUtil = AuthUtil
  Vue.$HelperUtil = Vue.prototype.$HelperUtil = HelperUtil
}

export default { install }